export const getDugnadProductSoldEquivalentToCollectedAmount = ({ subproject, projectRewards }) => {
    const purchasedRewards = subproject?.givers?.rewards || [];
    const [purchasedRewardCount, purchasedRewardValue] = purchasedRewards.reduce(
        (sum, reward) => {
            return [sum[0] + reward.count, sum[1] + reward.price * reward.count];
        },
        [0, 0]
    );
    const averageRewardPrice = projectRewards.reduce((sum, reward) => sum + reward.price, 0) / projectRewards.length;
    const collectedAmount = subproject?.sold_in_kr;
    const amountNotFromRewards = collectedAmount - purchasedRewardValue;
    const donationsEquivalentToRewardPurchases = amountNotFromRewards / averageRewardPrice;
    return purchasedRewardCount + donationsEquivalentToRewardPurchases;
};
